import Script from 'next/script';

const OutfunnelScript = () => {
  return (
    <Script id="outfunnel-config" strategy="lazyOnload">
      {`
        window.OFID = "5e62366438e5c01e50727587";
        ${process.env.NODE_ENV !== 'production' ? 'console.log("[Outfunnel] Set OFID:", window.OFID);' : ''}
      `}
    </Script>
  );
};

export default OutfunnelScript;